import "./contentelements/accordionOld";
import {PopUnder} from "./page/popunder";

import '../scss/styles.scss';

window.ytallowed = false;
import { Usercentrics } from "./general/usercentrics";

import 'focus-visible';

require('./polyfills/request-anim-frame');

import WindowEvents from './page/window-events';

import Collapse from "./basics/collapse";
import Image from "./basics/image";

// handle hover for touch devices in css
if (!("ontouchstart" in document.documentElement)) {
  document.documentElement.className += " no-touch";
}

let windowEvents = new WindowEvents();

let collapse = new Collapse();
let image = new Image();


import './contentelements/slider';
import MasonryLayout from "./contentelements/masonryLayout";


new MasonryLayout();


import './contentelements/seminarNav';
import './contentelements/peopleDetail';
import './contentelements/peopleFilter';
import './contentelements/publicationsPeople';
import './contentelements/modals';
import './contentelements/searchInput'

import "./forms/formVueForms";

if (window.showPopunder !== 0) {
  PopUnder.initPopUnder();
}
Usercentrics.handleYoutube();
